<template>
  <q-page>
    <div class="q-pa-md q-gutter-sm">
      <div class="row q-gutter-sm">

        <div v-if="false" class="col col-5">
          <div class="row">
            <div class="col col-12">
              <div class="text-h6"> 功能選單排序 </div>
              <q-btn class="q-mb-xs" color="red" label="重設選單" @click=resetMenuSortList ></q-btn>
              <ManagerMenu :data-list=allRouters></ManagerMenu>
            </div>
          </div>

        </div>

        <div class="col col-6">

          <div class="row g-gutter-sm">
            <div class="col col-12 q-mt-xs">
              <q-table
                title="系統參數設定"
                :data="settingList"
                :columns="columns"
                row-key="name"
                :pagination.sync="tableSet">
                <template v-slot:body="props">
                  <q-tr :props="props">
                    <q-td key="title" :props="props">{{ props.row.title }}</q-td>
                    <q-td key="value" :props="props">
                      <q-toggle v-model="props.row.value" color="blue"/> 
                    </q-td>
                  </q-tr>
                </template>
              </q-table>
            </div>
          </div>

        </div>
      </div>

    </div>
    <q-page-sticky position="top-right" :offset="[18, 18]">
      <q-btn
        v-if="handleEditPermission()"
        color="green"
        icon="create"
        label="更新"
        @click="SettingUpdate"
      ></q-btn>
    </q-page-sticky>
  </q-page>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import ManagerMenu from "./components/menu"
  export default {
    name: "ManagerSetting",
    components: { ManagerMenu },
    props: {},
    data() {
      return {
        columns: [
          { name: 'title', align: 'center', label: '功能簡述', field: 'title'},
          { name: 'value', label: '', field: 'value', align: 'center'},
        ],

        tableSet: {
          sortBy: 'desc',
          descending: false,
          page: 1,
          rowsPerPage: 10
        },
      }
    },
    computed: {
      ...mapGetters(['settingList', 'settingParentCompany', 'settingSubCompany', "loginUser", "allRouters"])
    },
    created() {
        this.$store.dispatch("SettingGetList")
    },
    methods: {
        handleEditPermission() {
        if (this.loginUser.permission && this.loginUser.permission.Setting > 2) {
          return true
        } else {
          return false
        }
      },
      ...mapActions(['SettingUpdate', 'resetMenuSortList', 'settingParentOrSubAdd', 'settingParentOrSubDelete'])
    }
  }
</script>